/**
 * Language Provider
 * Syncs i18n language with user preferences from auth store
 */

import { type ReactNode, useEffect } from "react"
import { useTranslation } from "react-i18next"
import { useAuthStore } from "@/features/auth/store/authStore"

interface LanguageProviderProps {
  children: ReactNode
}

export function LanguageProvider({ children }: LanguageProviderProps) {
  const { i18n } = useTranslation()
  const user = useAuthStore(state => state.user)

  // Sync i18n language with user preference
  useEffect(() => {
    const userLanguage = user?.userSettings?.languagePreferences

    if (userLanguage && userLanguage !== i18n.language) {
      i18n.changeLanguage(userLanguage)
    }
  }, [user?.userSettings?.languagePreferences, i18n])

  return <>{children}</>
}
